/**
 * Created by shadeeka on 6/4/19.
 */
import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash';
import { NavController } from '@ionic/angular';
import InspireTree from 'inspire-tree';
import { TFactoryMetaData, TFactoryState } from '@monorepo/types';
/*
 * This service is responsible for left navigation
 *
 * */
@Injectable({
  providedIn: 'root',
})
export class NavManager {
  private appDescriptor: TFactoryMetaData = {} as TFactoryMetaData;
  private inspireTree: InspireTree | undefined;
  private COMPONENTS = 'components';
  private VIEWS = 'views';
  public contextArgs = {};
  public ismMAnalytics: boolean = false;
  public isSkilli8Analytics: boolean = false;
  constructor(private navController: NavController) {}
  setupNavManager(factoryState: TFactoryState['factoryInfo']) {
    this.appDescriptor = factoryState?.meta_data || ({} as TFactoryMetaData); // keep app descriptor

    this.inspireTree = new InspireTree({
      data: this.appDescriptor.navigation,
    });
    this.inspireTree.expandDeep();
    window.dataSource = this.appDescriptor.ds;
  }

  clearNavigation() {
    this.appDescriptor = {} as TFactoryMetaData;
    this.inspireTree = undefined;
    window.dataSource = undefined;
    this.contextArgs = {};
  }

  getInspireTree() {
    return this.inspireTree;
  }
  reInitializeInspireTree(inspTree) {
    this.inspireTree = inspTree;
  }
  getInspireTreeAsArray() {
    return this.inspireTree?.toArray() || [];
  }

  private findFirstLeafWithView(tree) {
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i];
      if (!node['children'] || node['children'].length === 0) {
        const { view_type } = this.getViewById(node.args.view_id);
        if (view_type === '1' || view_type === '5' || view_type === '9') {
          return node;
        } else {
          continue;
        }
      } else {
        if (node['children'].length > 0) {
          return this.findFirstLeafWithView(node['children']);
        }
      }
    }
  }

  findItreeSelectedNode(tree) {
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i];
      if (node.defaultIdentifier) {
        return node;
      } else if (node.itree && node.itree.state && node.itree.state.selected) {
        node.defaultIdentifier = true;
        return node;
      } else {
        if (node['children'] && node['children'].length > 0) {
          return this.findItreeSelectedNode(node['children']);
        }
      }
    }
  }

  private findPathFromParent(node, arr) {
    const tempNode = cloneDeep(node);
    const result = cloneDeep(arr);
    if (tempNode && tempNode.itree && tempNode.itree.parent) {
      result.push(node.itree.parent.text);
      return this.findPathFromParent(tempNode.itree.parent, result);
    }

    return result;
  }
  findRootChild() {
    const nodes = this.getInspireTree()?.nodes() || [];
    const defaultNodeFromConfig = this.findItreeSelectedNode(nodes);

    return defaultNodeFromConfig || this.findFirstLeafWithView(nodes);
  }

  findNodeByOrgPath(path: Array<string>) {
    let tree = { children: this.getInspireTreeAsArray() };
    //TODOV4: Optimise this and handle the edge cases
    let node;
    for (let i = 0; i < path.length; i++) {
      node = tree.children.find((c) => c.text === path[i]);
      if (node) {
        tree = { children: node.children };
      } else {
        break;
      }
    }
    return node;
  }

  findMonitoringNode(params: string[]) {
    if (params.length < 4) {
      return;
    }
    const [t, v, s, d] = [...params];
    const stack = [...this.getInspireTreeAsArray()];

    while (stack.length > 0) {
      const node = stack.pop();
      const {
        args: { view_id, sbj, depth },
        text,
      } = node;
      if (text === t && view_id === v && s === sbj && d === depth.toString()) {
        // Found it!
        return node;
      } else if (node.children && node.children.length) {
        for (let ii = 0; ii < node.children.length; ii += 1) {
          if (node.children[ii]) {
            stack.push(node.children[ii]);
          }
        }
      }
    }

    // Didn't find it. Return null.
    return null;
  }

  getViewById(viewId) {
    let emptyView: Record<string, unknown> = {};
    try {
      const views = this.appDescriptor[this.VIEWS];
      views.forEach((item) => {
        if (item.view_id === viewId) {
          emptyView = item;
        }
      });
    } catch (e) {
      console.log('[Error] getViewById', emptyView);
    }
    return emptyView;
  }
  getComponentById(compId) {
    const components = this.appDescriptor[this.COMPONENTS];
    const found = components.find((comp) => comp.id === compId);
    return found;
  }
  getComboComponentById(compId) {
    const components = this.appDescriptor[this.COMPONENTS];
    const found = components.find((comp) => comp.id === compId);
    for (const key in found['args']['options']) {
      if (key === 'combo_component') {
        return found;
      }
    }
  }
  setContextArg(arg) {
    if (arg.msg instanceof Array) {
      arg.msg.forEach((item) => {
        this.contextArgs[item['@context_key']] = item['@context_value'];
      });
    } else {
      Object.assign(this.contextArgs, arg.msg);
    }
  }
  navigateToLayoutByNode(node) {
    const {
      args: { view_id, sbj, depth },
      text,
    } = node;
    const path = this.findPathFromParent(node, [text]).reverse();
    const { view_type } = this.getViewById(view_id);
    const urlParent = this.isSkilli8Analytics
      ? 'page-skilli8-analytics'
      : this.ismMAnalytics
      ? 'page-mm-analytics'
      : 'page-analytics';
    switch (view_type) {
      case '1': {
        this.navController.navigateRoot([`/${urlParent}/layout2`, ...path]);
        break;
      }
      case '9': {
        this.navController.navigateRoot([`/${urlParent}/layout7`, ...path]);
        break;
      }
      case '5': {
        //Encoding path to mask special char present in sbj in url
        const path = text + '???' + view_id + '???' + sbj + '???' + depth;
        this.navController.navigateRoot([`/${urlParent}/monitoring`, window.btoa(path)]);
        break;
      }
      default: {
        console.log('Please configure a view');
      }
    }
  }
  getAppConf() {
    return this.appDescriptor;
  }
}

export enum CUSTOM_EVENTS {
  CONFIG_LOADED,
  TOGGLE_ORG_HIERARCHY,
}
